<!-- RECEIVERS -->
<div *ngIf="isEdit">
  <div style="display: flex; align-items: flex-start; gap: 15px; margin-left: 24px">
    <div class="info-title">{{ 'Settings.ManageReceivers' | translate }}</div>
    <div (click)="showReceivers = !showReceivers" style="cursor: pointer">
      <mat-icon style="font-size: 24px" *ngIf="showReceivers">keyboard_arrow_up</mat-icon>
      <mat-icon style="font-size: 24px" *ngIf="!showReceivers">chevron_right</mat-icon>
    </div>
  </div>
  <div *ngIf="showReceivers" class="section-container">
    <div class="section-container-spacing">
      <!-- At least one receiver -->
      <div *ngIf="companiesService.currentCompany?.receivers?.length > 0">
        <div *ngFor="let receiver of companiesService.currentCompany.receivers">
          <div class="expanded-info-parent receiver-list" style="margin: 25px">
            <div class="expanded-info-column">
              <div class="expanded-info-title">
                <img
                  class="img"
                  [src]="
                    !companiesService.companyLogoErrorState
                      ? companiesService.currentCompany.logo
                      : 'assets/img/citymesh-logo-user.png'
                  "
                  alt
                  (error)="companiesService.handleImageError()"
                />
              </div>
            </div>
            <div class="expanded-info-column">
              <div class="expanded-info-title">
                {{ ('Settings.ReceiverName' | translate).toUpperCase() }}
              </div>
              <div class="text-style-value-row">
                {{ receiver.name || '-' }}
              </div>
            </div>

            <div class="expanded-info-column">
              <div class="expanded-info-title">
                {{ ('Settings.Apikey' | translate).toUpperCase() }}
              </div>
              <div class="text-style-value-row">
                {{ receiver.apiKey || '-' }}
              </div>
            </div>

            <div class="expanded-info-column">
              <div class="expanded-info-title">
                {{ ('Settings.IP' | translate).toUpperCase() }}
              </div>
              <div class="text-style-value-row">
                {{ convertToName(receiver.ip) }}
              </div>
            </div>

            <div class="expanded-info-column">
              <div class="expanded-info-title">
                {{ ('Settings.MonitoringPort' | translate).toUpperCase() }}
              </div>
              <div class="text-style-value-row">
                {{ receiver.monitoringPort || '-' }}
              </div>
            </div>

            <div class="expanded-info-column">
              <div class="expanded-info-title">
                {{ ('Settings.UdpPort' | translate).toUpperCase() }}
              </div>
              <div class="text-style-value-row">
                {{ receiver.receiverEventPort || '-' }}
              </div>
            </div>

            <div class="expanded-info-column">
              <div class="expanded-info-title">
                {{ ('Settings.SnifferPort' | translate).toUpperCase() }}
              </div>
              <div class="text-style-value-row">
                {{ receiver.snifferPort || '-' }}
              </div>
            </div>
          </div>
          <div class="separator"></div>
        </div>
      </div>

      <!-- No receivers -->
      <div
        *ngIf="!companiesService.currentCompany?.receivers || companiesService.currentCompany?.receivers.length === 0"
        class="line-box"
      >
        <img src="assets/icons/add_circle.svg" alt class="line-box-icon" />
        <div class="line-box-title">{{ 'Settings.AddReceiver' | translate }}</div>
        <p class="line-box-desc" [innerHTML]="receiverMessage"></p>
      </div>
    </div>
  </div>
</div>

<!-- USERS -->
<div *ngIf="userAddNewUsers()">
  <div style="display: flex; align-items: flex-start; gap: 15px; margin-left: 24px">
    <div class="info-title">{{ 'Settings.ManageUsers' | translate }}</div>
    <div (click)="showUsers = !showUsers" style="cursor: pointer">
      <mat-icon style="font-size: 24px" *ngIf="showUsers">keyboard_arrow_up</mat-icon>
      <mat-icon style="font-size: 24px" *ngIf="!showUsers">chevron_right</mat-icon>
    </div>
  </div>
  <div *ngIf="showUsers" class="section-container">
    <div class="section-container-spacing">
      <!-- At least one user -->
      <div *ngIf="companiesService.currentCompany?.users?.length > 0">
        <div *ngFor="let user of companiesService.currentCompany.users">
          <div class="expanded-info-parent" style="margin: 25px">
            <div class="expanded-info-column">
              <div class="expanded-info-title">
                {{ ('Settings.Name' | translate).toUpperCase() }}
              </div>
              <div class="text-style-value-row">
                {{ user.name || '-' }}
              </div>
            </div>

            <div class="expanded-info-column">
              <div class="expanded-info-title">
                {{ ('Settings.Lastname' | translate).toUpperCase() }}
              </div>
              <div class="text-style-value-row">
                {{ user.lastName || '-' }}
              </div>
            </div>

            <div class="expanded-info-column">
              <div class="expanded-info-title">
                {{ ('Settings.Email' | translate).toUpperCase() }}
              </div>
              <div class="text-style-value-row">
                {{ user.email || '-' }}
              </div>
            </div>

            <div
              class="expanded-info-column"
              *ngIf="companiesService.enableEditPermission(user, companiesService.currentCompany)"
            >
              <div class="expanded-info-title">
                {{ ('Settings.Permissions' | translate).toUpperCase() }}
              </div>
              <div
                fxLayout="row"
                fxLayoutGap="20px"
                class="selector-field"
                (click)="
                  contextualMenuService.onContextalMenu(
                    $event,
                    user,
                    !user.expand,
                    'permission-selector-edit-' + user.email
                  )
                "
                onKeyPress
                onKeyDown
                onKeyUp
              >
                <div class="text-style-value-row">{{ 'Settings.UserLevel.' + user.role | translate }}</div>
                <mat-icon [id]="'permission-selector-edit-' + user.email" class="permission-selector"
                  >keyboard_arrow_down</mat-icon
                >
              </div>
            </div>

            <div
              class="expanded-info-column"
              *ngIf="!companiesService.enableEditPermission(user, companiesService.currentCompany)"
            >
              <div class="expanded-info-title">
                {{ ('Settings.Permissions' | translate).toUpperCase() }}
              </div>
              <div class="text-style-value-row">
                {{ user.role ? ('Settings.UserLevel.' + user.role | translate) : '-' }}
              </div>
            </div>

            <div class="expanded-info-column-remove-button">
              <mat-icon
                class="icon"
                [style.color]="allowed(user) ? '#243757' : '#808080'"
                [ngClass]="getButtonClass(user)"
                (click)="editUser(user)"
                onKeyPress
                onKeyDown
                onKeyUp
              >
                edit
              </mat-icon>
              <mat-icon
                class="icon"
                [ngClass]="getButtonClass(user)"
                svgIcon="delete_icon"
                (click)="deleteUser(user)"
                onKeyPress
                onKeyDown
                onKeyUp
              ></mat-icon>
            </div>
          </div>
          <div class="separator"></div>
        </div>
      </div>

      <!-- No users -->
      <div
        *ngIf="!companiesService.currentCompany?.users || companiesService.currentCompany?.users.length === 0"
        class="line-box"
      >
        <img src="assets/icons/person.svg" alt class="line-box-icon" />
        <div class="line-box-title">{{ 'Settings.AddUsers' | translate }}</div>
        <p class="line-box-desc" [innerHTML]="userMessage"></p>
      </div>
    </div>
  </div>
</div>
